import { render, staticRenderFns } from "./StudentCounseModal.vue?vue&type=template&id=e4bd63be&scoped=true"
import script from "./StudentCounseModal.vue?vue&type=script&lang=js"
export * from "./StudentCounseModal.vue?vue&type=script&lang=js"
import style0 from "./StudentCounseModal.vue?vue&type=style&index=0&id=e4bd63be&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bd63be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4bd63be')) {
      api.createRecord('e4bd63be', component.options)
    } else {
      api.reload('e4bd63be', component.options)
    }
    module.hot.accept("./StudentCounseModal.vue?vue&type=template&id=e4bd63be&scoped=true", function () {
      api.rerender('e4bd63be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/DynamicMonitor/components/StudentProfile/components/StudentCounseModal.vue"
export default component.exports